<template>
  <div style="position: relative">
    <span
      class="input input--chisato"
      :class="{ 'input--filled': !!selection, 'invalid': this.isInvalid || !this.addressIsCorrect, 'invalid--address': !this.addressIsCorrect}">
      <input
        class="field input__field input__field--chisato input-suggestion"
        id="delivery-address"
        type="text"
        ref="suggestionInput"
        :value="selection"
        @input="inputHandler"
        @focus="checkAndScroll()"
        @focusout="focusOutHandler"
        @keydown.enter.prevent.stop="enter(null)"
        @keydown.down="down"
        @keydown.up="up"
        @keydown="debounceInput"
        autocomplete="off"
      />
      <label class="input__label input__label--chisato" for="delivery-address">
        <span
          class="input__label-content input__label-content--chisato"
          data-content="Улица и дом"
        >
          Улица и дом</span>
        </label>
      <div class="notice with-icon" v-if="!addressIsCorrect">Укажите максимально подробную информацию, куда доставить заказ.</div>
    </span>
    <div class="dropdown--list shadow-bottom" v-if="openSuggestion">
      <div
        class="dropdown--item"
        v-for="(suggestion, index) in matches"
        :key="index"
        @mouseover="current = index"
        @click="enter(index)"
      >
        <span
          :class="{'suggest-item--active': current === index}"
          style="text-align: left;"
        >
          {{ suggestion.text }}
        </span>
        <p style="flex-grow: 1; margin-left: 10px;"></p>
        <span class="enter-action" v-if="current === index && !isMobile">enter</span>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import axios from 'axios'
import { getTopPosition } from '@/utils.js'

export default {
  data () {
    return {
      open: true,
      current: 0,
      selection: this.oldAddress,
      house: null,
      matches: [],
      showHouseError: false,
      addressSelectedFromSuggestion: false
    }
  },
  props: {
    isInvalid: {
      type: Boolean,
      default: false
    },
    currentCity: {
      type: String,
      default: ''
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    addressIsCorrect: {
      type: Boolean,
      default: true
    },
    oldAddress: {
      type: String,
      default: ''
    }
  },
  methods: {
    inputHandler ({ target }) {
      this.house = null
      this.selection = target.value
    },
    focusOutHandler () {
      setTimeout(() => {
        this.open = false
        this.sendInputEvent()
      }, 1000)
    },
    enter (index = null) {
      this.addressSelectedFromSuggestion = true
      if (index === null) {
        this.selection = this.matches[this.current].text
      } else {
        this.selection = this.matches[index].text
      }
      this.house = this.matches[this.current].house
      this.open = false
      this.showHouseError = this.matches[this.current].house === null
      this.$emit('on-suggestion-click', this.matches[this.current])
      this.$nextTick(() => {
        const el = this.$refs.suggestionInput
        el.blur()
        el.focus()
      })
    },
    scrollToItem (type) {
      document.getElementsByClassName('dropdown--list')[0].scrollTop = document.getElementsByClassName('suggest-item--active')[0].offsetTop - (type === 'up' ? 60 : 0)
    },
    down () {
      if (this.current < this.matches.length - 1) this.current++
      this.scrollToItem('down')
    },
    up () {
      if (this.current > 0) this.current--
      this.scrollToItem('up')
    },
    sendInputEvent () {
      this.$emit('on-input', { text: this.selection, house: this.house })
    },
    getSuggestion () {
      if (this.selection.length < 1) {
        return undefined
      }
      this.open = true
      this.matches = []
      this.current = 0
      const payload = {}
      payload.query = `${this.selection}`
      payload.count = 10
      // payload.from_bound = { value: 'street' }
      payload.to_bound = { value: 'house' }
      payload.locations = [{ country_iso_code: 'BY', region: this.currentCity }]
      axios.post('/dadata/', payload)
        .then(res => {
          const { suggestions } = res.data
          if (suggestions.length === 0) {
            return undefined
          }
          this.matches = suggestions.map(x => {
            return {
              text: x.value,
              house: x.data.house
            }
          })
        })
      this.sendInputEvent()
    },
    checkAndScroll () {
      if (!this.isMobile) {
        return undefined
      }
      window.scrollTo({ top: getTopPosition(this.$el), behavior: 'smooth' })
    },
    debounceInput: _.debounce(function ({ keyCode }) {
      if (keyCode === 40 ||
        keyCode === 38 ||
        keyCode === 13) {
        return undefined
      }
      if (keyCode === 9) {
        this.open = false
        return undefined
      }
      this.getSuggestion()
    }, 100)
  },
  computed: {
    openSuggestion () {
      return this.selection !== '' &&
        this.matches.length !== 0 && this.open === true
    }
  }
}
</script>

<style src="@/components/Cards.css" scoped/>

<style scoped>
@media screen and (max-width: 1023px) {
  .dropdown--list {
    width: 100%;
    max-width: 332px;
  }
}
  .input-suggestion {
    display: inline-flex;
  }
  .auto-complete {
    position: relative;
  }
  .dropdown--list {
    position: absolute;
    font: inherit;
    background: #FAFAFA !important;
    max-height: 200px;
    width: 425px;
    overflow-y: auto;
    margin: 0 auto;
    z-index: 20;
    left: 50%;
    top: 75px;
    transform: translate(-50%);
  }
  .dropdown--item {
    margin: 15px;
    cursor: pointer;
    display: flex;
    align-items: center;
  }
  .enter-action {
    font-size: 12px;
    line-height: 15px;
    font-weight: 500;
  }

  .shadow-bottom {
    box-shadow: inset 0px -11px 8px -10px #CCC;
  }
  .suggest-item--active {
    color: #B68B55;
  }
  span.input.invalid--address::after {
    content: 'Пожалуйста, введите номер дома';
    display: inline-block;
    position: absolute;
    bottom: -16px;
    left: 1px;
    font-size: 13px;
    font-weight: 100;
    width: 250px;
    color: rgba(255, 0, 0, 0.5);
    text-align: left;
  }
</style>
